const loadingLabel = "Henter";
const daDK = {
  loadingLabel
};
export {
  daDK as default,
  loadingLabel
};
